import { render, staticRenderFns } from "./ConfiguracaoRastreabilidade.vue?vue&type=template&id=1afc02f4&lang=pug"
import script from "./ConfiguracaoRastreabilidade.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoRastreabilidade.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoRastreabilidade.vue?vue&type=style&index=0&id=1afc02f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports